// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageDetails_root__2evwB","info":"ImageDetails_info__2U-Rv","title":"ImageDetails_title__2k2Fi","edit":"ImageDetails_edit__3ZeLu"};